(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('SupplierCoupon', SupplierCoupon);

    SupplierCoupon.$inject = ['$resource', 'DateUtils'];

    function SupplierCoupon($resource, DateUtils) {
        var resourceUrl = 'api/supplier-coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
